import React from 'react'
import AboutComponent from '../../components/About/AboutComponent'

const About = () => {
  return (
    <div>
        <AboutComponent />
    </div>
  )
}


export default About